import { classnames } from '@aibees/shared/utils';
import {
  Autocomplete,
  Chip,
  InputLabel,
  Stack,
  TextField,
  Typography,
} from '@mui/material';
import { memo, useState } from 'react';
import { Icon } from '../icon';
import * as Styled from './styles';
import * as SX from './sx';
import type { CustomMultiselectProps as Props, Option } from './types';

export const CustomMultiselect = memo(
  ({
    className,
    options,
    chipSX,
    deleteIconSx,
    deleteIconSize,
    optionSx,
    chipIcon,
    chipIconSx,
    inputSx,
    placeholder: placeholer,
  }: Props) => {
    const [values, setValue] = useState<Option[]>([]);

    return (
      <Styled.Wrapper
        className={classnames('CustomMultiselect', className)}
        sx={SX.root}
      >
        {!values.length && (
          <InputLabel
            disableAnimation
            sx={SX.label}
            focused={false}
            shrink={false}
            id="tags-outlined"
          >
            {placeholer}
          </InputLabel>
        )}

        <Autocomplete
          multiple
          id="tags-outlined"
          limitTags={2}
          options={options}
          getOptionLabel={(option) => option.title}
          filterSelectedOptions
          renderInput={(params) => (
            <TextField {...params} sx={inputSx} autoComplete="off" />
          )}
          renderTags={(value: readonly Option[], getTagProps) =>
            value.map((option: Option, index: number) => (
              <Chip
                sx={chipSX || SX.chip}
                variant="outlined"
                label={
                  <Stack direction="row" alignItems="center">
                    {chipIcon && <Icon name={chipIcon} sxx={chipIconSx} />}
                    {option.title}
                  </Stack>
                }
                key={option.title}
                onDelete={getTagProps({ index }).onDelete}
                tabIndex={getTagProps({ index }).tabIndex}
                deleteIcon={
                  <Icon
                    name="close"
                    size={deleteIconSize || 18}
                    sxx={deleteIconSx || SX.deleteIcon}
                  />
                }
              />
            ))
          }
          renderOption={(props, option) => (
            <Stack
              direction="row"
              justifyContent="space-between"
              alignItems="center"
              gap={10}
              component="li"
              sx={optionSx || SX.optionItem}
              // {...props.}
              onClick={props.onClick}
              value={option.value}
            >
              <Stack
                direction="row"
                justifyContent="space-between"
                alignItems="center"
                gap={1}
              >
                {option.icon && <Icon name={option.icon || 'fingerPrint'} />}
                <Typography>{option.title}</Typography>
              </Stack>
              <Typography>{option.count}</Typography>
            </Stack>
          )}
          onChange={(e, value) => setValue(value)}
        />
      </Styled.Wrapper>
    );
  }
);

CustomMultiselect.displayName = 'CustomMultiselect';
